/*
 * /people (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Container, Divider, Page, PageHeader } from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { PersonList } from "../../features/people/components/person-list"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/people/")({
	component: PeoplePage,
	loader: authPageLoader,
})

function PeoplePage() {
	const { user } = Route.useLoaderData()

	const {
		data: people,
		isLoading,
		refetch,
	} = trpc.person.getAllByFilter.useQuery({
		where: { userId: user.id },
		sort: { column: "createdAt", direction: "asc" },
	})

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"People"}
					left={{
						href: "/dashboard",
						label: "Dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<PersonList
					userId={user.id}
					people={people || []}
					isLoading={isLoading}
					onChanged={refetch}
				/>
			</Container>
		</Page>
	)
}
